import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import React from "react";
import KitchenIcon from "@mui/icons-material/Kitchen";

// Create a memoized Select component to reduce re-renders
const MemoizedSelect = React.memo(({ value, onChange, options }) => (
  <Select
    value={value}
    onChange={onChange}
    fullWidth
    placeholder="Select container type"
  >
    {options.map((option) => (
      <MenuItem key={option} value={option}>
        {option.replace("choose_", "").replace(/_/g, " ").toUpperCase()}
      </MenuItem>
    ))}
  </Select>
));

MemoizedSelect.displayName = "MemoizedSelect";

// Memoized dialog content
const DialogContent1 = React.memo(({ missingIngredient }) => (
  <Box sx={{ bgcolor: "info.light", p: 2, borderRadius: 1 }}>
    <Typography variant="body1" textAlign="center">
      We need to know which container type to use for{" "}
      <strong>{missingIngredient}</strong>
    </Typography>
    <Typography
      variant="body2"
      color="text.primary"
      textAlign="center"
      sx={{ mt: 1 }}
    >
      Please select the container type:
    </Typography>
  </Box>
));

DialogContent1.displayName = "DialogContent1";

const SwapDialog = React.memo(
  ({
    open,
    onClose,
    choosedSwapedTask,
    setChoosedSwapedTask,
    swapOptions,
    onConfirm,
    missingIngredient = "this ingredient", // New prop for the missing ingredient name
  }) => {
    const handleChange = (e) => {
      setChoosedSwapedTask(e.target.value);
    };

    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ textAlign: "center", pb: 0 }}>
          <KitchenIcon color="warning" sx={{ fontSize: 32, mb: 1 }} />
          <Typography variant="h6" color="primary.main" fontWeight="bold">
            Select Container Type
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={3} sx={{ mt: 2 }}>
            <DialogContent1 missingIngredient={missingIngredient} />

            <MemoizedSelect
              value={choosedSwapedTask}
              onChange={handleChange}
              options={swapOptions}
            />
          </Stack>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", p: 3 }}>
          <Button
            onClick={onClose}
            variant="outlined"
            color="error"
            sx={{ mx: 1, px: 3 }}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            variant="contained"
            color="primary"
            sx={{ mx: 1, px: 3 }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

SwapDialog.displayName = "SwapDialog";

export default SwapDialog;
